import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../../assets/img/icons/up-down-aroow.svg'
import _imports_1 from '../../../assets/img/icons/eye.svg'
import _imports_2 from '../../../assets/img/icons/edit.svg'
import _imports_3 from '../../../assets/img/icons/close.svg'
import _imports_4 from '../../../assets/img/icons/left-arrow-purple.svg'
import _imports_5 from '../../../assets/img/icons/right-arrow-purple.svg'


const _hoisted_1 = { class: "card border-0 shadow-none rounded-1 mb-25" }
const _hoisted_2 = { class: "card-body p-xl-40" }
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_5 = { class: "shadow-none fw-normal text-black title ps-0" }
const _hoisted_6 = { class: "d-flex align-items-center product-item border" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_9 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_10 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_11 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_12 = { class: "shadow-none lh-1 fs-14 fw-normal text-paragraph" }
const _hoisted_13 = { class: "shadow-none lh-1 text-end pe-0" }
const _hoisted_14 = { class: "button-group d-flex align-items-center" }
const _hoisted_15 = { class: "row pb-45 align-items-center" }
const _hoisted_16 = { class: "col-sm-6" }
const _hoisted_17 = { class: "d-flex flex-wrap align-items-center justify-content-center justify-content-sm-start page-unit" }
const _hoisted_18 = { class: "col-sm-6 text-sm-end text-center" }
const _hoisted_19 = { class: "page-nav list-style" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("table", _hoisted_4, [
            _cache[7] || (_cache[7] = _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-title fw-normal fs-14 pt-0"
                }, "IMAGE"),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-title fw-normal fs-14 pt-0"
                }, [
                  _createTextVNode(" NAME "),
                  _createElementVNode("img", {
                    class: "ms-2",
                    src: _imports_0,
                    alt: "Image"
                  })
                ]),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-title fw-normal fs-14 pt-0"
                }, [
                  _createTextVNode(" CODE "),
                  _createElementVNode("img", {
                    class: "ms-2",
                    src: _imports_0,
                    alt: "Image"
                  })
                ]),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-title fw-normal fs-14 pt-0"
                }, [
                  _createTextVNode(" CATEGORY "),
                  _createElementVNode("img", {
                    class: "ms-2",
                    src: _imports_0,
                    alt: "Image"
                  })
                ]),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-title fw-normal fs-14 pt-0"
                }, [
                  _createTextVNode(" PRICE "),
                  _createElementVNode("img", {
                    class: "ms-2",
                    src: _imports_0,
                    alt: "Image"
                  })
                ]),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-title fw-normal fs-14 pt-0"
                }, [
                  _createTextVNode(" QUANTITY "),
                  _createElementVNode("img", {
                    class: "ms-2",
                    src: _imports_0,
                    alt: "Image"
                  })
                ]),
                _createElementVNode("th", {
                  scope: "col",
                  class: "text-title fw-normal fs-14 pt-0"
                }, "ACTION")
              ])
            ], -1)),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: product.id
                }, [
                  _createElementVNode("td", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("img", {
                        src: require('../../../assets/img/products/product-thumb-7.webp'),
                        alt: "Image"
                      }, null, 8, _hoisted_7)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_8, _toDisplayString(product.name), 1),
                  _createElementVNode("td", _hoisted_9, _toDisplayString(product.barCode), 1),
                  _createElementVNode("td", _hoisted_10, _toDisplayString(product.categoryName), 1),
                  _createElementVNode("td", _hoisted_11, _toDisplayString(product.price), 1),
                  _createElementVNode("td", _hoisted_12, _toDisplayString(product.quantity), 1),
                  _createElementVNode("td", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_router_link, {
                        to: { name: 'ProductDetails', params: { id: product.id } },
                        title: "View",
                        class: "me-2"
                      }, {
                        default: _withCtx(() => _cache[4] || (_cache[4] = [
                          _createElementVNode("img", {
                            src: _imports_1,
                            alt: "Image"
                          }, null, -1)
                        ])),
                        _: 2,
                        __: [4]
                      }, 1032, ["to"]),
                      _createVNode(_component_router_link, {
                        to: { name: 'EditProduct', params: { id: product.id } },
                        title: "Edit",
                        class: "me-2"
                      }, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createElementVNode("img", {
                            src: _imports_2,
                            alt: "Image"
                          }, null, -1)
                        ])),
                        _: 2,
                        __: [5]
                      }, 1032, ["to"]),
                      _cache[6] || (_cache[6] = _createElementVNode("a", {
                        class: "delete-btn",
                        href: "#",
                        role: "button"
                      }, [
                        _createElementVNode("img", {
                          src: _imports_3,
                          alt: "Image"
                        })
                      ], -1))
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _cache[9] || (_cache[9] = _createElementVNode("span", { class: "fs-13" }, "Showing product per page", -1)),
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.pageSize) = $event)),
            onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changePageSize && _ctx.changePageSize(...args))),
            class: "text-title border-0 fs-14 bg-transparent"
          }, _cache[8] || (_cache[8] = [
            _createElementVNode("option", { value: "10" }, "10", -1),
            _createElementVNode("option", { value: "20" }, "20", -1),
            _createElementVNode("option", { value: "30" }, "30", -1)
          ]), 544), [
            [_vModelSelect, _ctx.pageSize]
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("ul", _hoisted_19, [
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.previousPage && _ctx.previousPage(...args))),
              disabled: _ctx.currentPage === 1
            }, _cache[10] || (_cache[10] = [
              _createElementVNode("img", {
                src: _imports_4,
                alt: "Image"
              }, null, -1)
            ]), 8, _hoisted_20)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visiblePages, (page) => {
            return (_openBlock(), _createElementBlock("li", { key: page }, [
              _createElementVNode("a", {
                onClick: ($event: any) => (_ctx.goToPage(page)),
                class: _normalizeClass({ active: page === _ctx.currentPage })
              }, _toDisplayString(page), 11, _hoisted_21)
            ]))
          }), 128)),
          _createElementVNode("li", null, [
            _createElementVNode("a", {
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
              disabled: _ctx.currentPage === _ctx.totalPages
            }, _cache[11] || (_cache[11] = [
              _createElementVNode("img", {
                src: _imports_5,
                alt: "Image"
              }, null, -1)
            ]), 8, _hoisted_22)
          ])
        ])
      ])
    ])
  ], 64))
}